import React from 'react';
import { graphql, PageProps } from 'gatsby';
import { HealthMap } from '@components';
import { THealthPageProperties } from '.';
import { StyledMapWrapper } from './health.styled';

export default function Health({ data }: PageProps<THealthPageProperties>) {
    const { markdownRemark } = data;
    return (
        <main>
            <StyledMapWrapper>
                <HealthMap frontmatter={markdownRemark.frontmatter} />
            </StyledMapWrapper>
        </main>
    );
}

export const pageQuery = graphql`
    query HealthPageTemplate {
        markdownRemark(frontmatter: { path: { eq: "health" } }) {
            frontmatter {
                path
                metadataPageTitle
                healthMapHeading
                healthMapSubheading
                metadataPageDescription
                healthMapSideBarCopy
            }
        }
    }
`;
